<template>
  <div class="amazon_edit" style="width: 90%">
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <div id="main">
      <el-form ref="basicForm" label-width="200px" :model="basicForm">
        <div id="basic" class="basic">
          <div class="title">基础信息</div>
          <el-form-item
            prop="templateName"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="模板名称："
          >
            <el-input
              :disabled="templateId.length > 0"
              size="mini"
              v-model="basicForm.templateName"
            ></el-input>
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            prop="templateState"
            label="模板国家："
          >
            <el-select
              clearable
              :disabled="templateId.length > 0"
              style="width: 100%"
              size="mini"
              v-model="basicForm.templateState"
              placeholder="请选择模板国家"
              @change="handleChangeState"
            >
              <el-option
                v-for="(value, index) in dictData['amazon_site']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="platId"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="产品分类："
          >
            <el-cascader
              style="width: 100%"
              size="mini"
              expand-trigger="hover"
              :options="platTypeList"
              :props="optionProps"
              v-model="basicForm.platId"
              @change="handleChangePlatId"
              :disabled="templateId.length > 0"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            prop="templateState"
            label="售卖方式："
          >
            <el-radio-group v-model="basicForm.saleForm">
              <template v-for="record in dictData['sale_form']">
                <el-radio :label="record.value" :key="record.value">
                  {{ record.label }}</el-radio
                >
              </template>
            </el-radio-group>
            <div v-if="basicForm.saleForm == '04'">
              <el-form-item
                style="margin: 0 0 0 -69px"
                prop="groupNum"
                :rules="[
                  { required: true, message: '请输入内容', trigger: 'blur' },
                ]"
                label="合并产品数量："
              >
                <el-input
                  v-model="basicForm.groupNum"
                  placeholder="请输入内容"
                  size="mini"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                style="margin: 0 0 0 -69px"
                prop="color_name"
                :rules="[
                  { required: true, message: '请输入内容', trigger: 'blur' },
                ]"
                label="颜色名称生成规则："
              >
                <div class="variable-insert">
                  <div class="insert-link">
                    插入变量
                    <div class="variable-select-menu">
                      <ul>
                        <li
                          class="variable-select-box-text"
                          :key="number"
                          v-for="(record, number) in varList"
                          @click="handleInsertColorSize(record.var)"
                        >
                          {{ record.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <i
                    @mouseenter="handleShowVarHelp"
                    @mouseout="showVarHelp = false"
                    class="el-icon-question"
                  ></i>
                </div>
                <el-input
                  id="textarea_color"
                  ref="textarea_color"
                  v-model="basicForm.color_name"
                  type="textarea"
                  placeholder="请输入内容"
                  show-word-limit
                  :rows="3"
                  size="mini"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item v-if="designId || pId" prop="quantity" label="">
            <el-button
              size="small"
              type="primary"
              @click="priceConfigVisible = true"
              >指定颜色、尺码汇出</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="sizeColorVisible = true"
              >颜色、尺码名称自定义</el-button
            >
          </el-form-item>
          <el-form-item
            prop="external_product_id_type"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="商品编码类型："
          >
            <el-select
              style="width: 100%"
              clearable
              size="mini"
              v-model="basicForm.external_product_id_type"
              placeholder="请选择"
              @change="handleChangeProductType"
            >
              <el-option
                v-for="(record, index) in externalProductIdTypeOptions"
                :label="record.engValName"
                :value="record.engValName"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            prop="external_product_id"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="商品编码："
          >
            <el-select
              style="width: 100%"
              clearable
              size="mini"
              v-model="basicForm.external_product_id"
              placeholder="请选择"
            >
              <el-option
                v-for="(record, index) in productIds"
                :key="index"
                :label="record.name"
                :value="record.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            prop="productPicAddr"
            label="同步产品图片地址："
          >
            <el-select
              clearable
              style="width: 100%"
              size="mini"
              v-model="basicForm.productPicAddr"
              placeholder="请选择产品图片地址"
            >
              <el-option
                v-for="(record, index) in pictureAddresses"
                :key="index"
                :label="record"
                :value="record"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item style="margin-bottom: 0" label="产品图片：">
            <span class="form-label" slot="label">
              <span style="color: red; margin: 0 5px 0 0">*</span>产品图片：
            </span>
            <div class="image-hint" style="position: relative">
              <div>
                点击图片拖动，即可调整图片顺序！ [图片最多选择9张，已经选择了{{
                  imageGroup.length
                }}张]
              </div>
              <div>
                每个变种将分别按照以下顺序汇出图片。[可在定制产品列表查看产品各颜色的效果图]
              </div>
            </div>
            <div
              style="
                display: inline-block;
                margin: 0 0 0 8px;
                position: relative;
              "
              @click="showPicSize = true"
            >
              <span style="right: 10px; top: -2px; color: #4934b2">
                <span class="size_name_style is_main active"
                  ><span
                    ><i
                      class="el-icon-full-screen"
                      style="margin: 0 4px 0 0"
                    ></i
                    >尺寸调整（{{ basicForm.picSizeW }} x
                    {{ basicForm.picSizeH }}px）
                    <i
                      class="icon-screen_low f14 pa"
                      style="top: 0px; right: -14px"
                    ></i>
                  </span>
                </span>
              </span>
            </div>
            <div
              v-if="showPicSize"
              style="
                position: absolute;
                left: 0px;
                top: 117px;
                z-index: 100;
                padding: 8px;
              "
              class="imgSize-box active is_main"
            >
              <div class="cont">
                <el-radio-group style="display: block" v-model="sizeConfig">
                  <el-radio style="display: block; margin: 16px 0" :label="1600"
                    >1600 x 1600px(默认)</el-radio
                  >
                  <el-radio style="display: block; margin: 16px 0" :label="800"
                    >800 x 800px</el-radio
                  >
                  <el-radio style="display: block; margin: 16px 0" :label="1200"
                    >1200 x 1200px</el-radio
                  >
                  <el-radio style="display: block; margin: 16px 0" :label="2000"
                    >2000 x 2000px</el-radio
                  >
                  <el-radio
                    style="display: block; margin: 16px 0 0 0"
                    :label="0"
                    >自定义</el-radio
                  >
                </el-radio-group>
                <div v-if="sizeConfig == 0">
                  <input
                    placeholder="宽度"
                    v-model="picSizeW"
                    style="width: 60px; line-height: 24px; margin: 0 16px 0 0"
                  />
                  x
                  <input
                    v-model="picSizeH"
                    placeholder="高度"
                    style="width: 60px; line-height: 24px"
                  />
                </div>
              </div>
              <div class="foot" style="text-align: center">
                <el-button @click="showPicSize = false" size="small"
                  >取消</el-button
                >
                <el-button
                  size="small"
                  @click="handleSavePicSize"
                  type="primary"
                  >保存</el-button
                >
              </div>
            </div>
            <ul
              class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
            >
              <draggable
                :list="imageGroup"
                style="overflow: hidden; display: inline-block"
                filter=".forbid"
                @start="drag = true"
                @end="drag = false"
                :move="onMove"
              >
                <li
                  v-for="(record, index) in imageGroup"
                  :key="index"
                  class="sort-img-item"
                  :class="index === 0 ? 'forbid' : ''"
                >
                  <div v-if="record.isMain" class="item-badge">主图</div>
                  <p v-if="record.imageUrl.indexOf('http') === -1">
                    效果图{{ record.imageUrl }}
                  </p>
                  <img v-else :src="record.imageUrl" />
                  <span class="first-pro-icon icon-corner-mark"></span>
                  <div class="wish-product-img-ope">
                    <a
                      @click.prevent="handleSetMainImage(record, index)"
                      class="set-main"
                      >设为主图</a
                    >
                    <a
                      @click.prevent="hanldeDeleteImage(record, index)"
                      class="set-delete"
                      >移除</a
                    >
                  </div>
                </li>
              </draggable>
              <li
                class="forbid"
                :class="{ 'add-image-button': true }"
                v-if="imageGroup.length < 9"
              >
                <p><i class="el-icon-plus"></i></p>
                <div class="variable-select-box">
                  <ul>
                    <li>
                      插入变量
                      <ul class="variable-pick-ul">
                        <li
                          @click="handleAddSample(record)"
                          v-for="record in imageSamples"
                          :key="record"
                        >
                          效果图{{ record }}
                        </li>
                      </ul>
                    </li>
                    <li @click="handleUploadImage">本地图片</li>
                  </ul>
                </div>
              </li>
            </ul>
          </el-form-item>
          <el-form-item
            prop="quantity"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="库存："
          >
            <div class="form-label" slot="label">
              库存：<br />
              <div class="field-name">（quantity）</div>
            </div>
            <el-input
              onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
              size="mini"
              v-model="basicForm.quantity"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div id="template" v-if="basicForm.platId" class="title">属性信息</div>
      <div v-if="basicForm.platId" class="check-list">
        <el-checkbox
          style="display: inline-block; margin-right: 39px"
          v-model="checkedAll"
          @change="handleCheckAll"
          >全部</el-checkbox
        >
        <el-checkbox-group
          style="display: inline-block"
          v-model="templateViews"
        >
          <el-checkbox label="Required" disabled>重要信息</el-checkbox>
          <el-checkbox label="Preferred">首选信息</el-checkbox>
          <el-checkbox label="Optional">可选信息</el-checkbox>
        </el-checkbox-group>
      </div>
      <el-form
        v-for="(record, index) of groups"
        :ref="`form${index}`"
        :key="index"
        :model="forms[index]"
        label-width="200px"
        v-if="
          templateViews.includes(groups[index][0].importType) &&
            groups[index][0].groupBy !== 'proPicGroup'
        "
      >
        <div class="basic">
          <div
            @click="groups[index][0].visible = !groups[index][0].visible"
            class="form-title"
          >
            <i v-if="!groups[index][0].visible" class="el-icon-plus"></i>
            <i v-if="groups[index][0].visible" class="el-icon-minus"></i>
            {{ groups[index][0].groupBy }}
          </div>
          <div v-if="groups[index][0].visible" class="form-content">
            <el-form-item
              v-for="(item, number) of record"
              :label="item.labelName + '：'"
              :key="number"
              :prop="item.attrId"
              :rules="
                (item.importType === 'Required' ||
                  item.importType === '必須') &&
                !item.disabled &&
                item.fieldName !== 'item_sku'
                  ? [{ required: true, message: '请输入内容', trigger: 'blur' }]
                  : []
              "
              v-if="
                !(
                  item.fieldName == 'quantity' ||
                  item.fieldName == 'external_product_id_type' ||
                  item.fieldName == 'external_product_id'
                )
              "
            >
              <div class="form-label" slot="label">
                <div
                  :title="item.labelName"
                  style="width: 176px"
                  class="text-ellipsis"
                >
                  {{ item.labelName }}：
                </div>
                <div
                  :title="item.fieldName"
                  style="width: 176px"
                  class="text-ellipsis field-name"
                >
                  （{{ item.fieldName }}）
                </div>
              </div>
              <div v-if="false" style="display: inline-block" slot="label">
                <!-- <p>{{ item.labelName }}：</p> -->
                <!-- <p style="font-size:12px;">{{ item.fieldName }}</p> -->
              </div>
              <div class="form-control">
                <input
                  class="com-search-input w100"
                  v-if="
                    item.disabled &&
                      item.fieldName != 'age_range_description' &&
                      item.fieldName != 'footwear_age_group'
                  "
                  size="mini"
                  :disabled="true"
                  placeholder="根据汇出的产品自动生成"
                />
                <div
                  v-else-if="
                    item.dataType == '01' && item.fieldName == 'item_sku'
                  "
                >
                  <input
                    class="com-search-input"
                    v-model="itemSkuBefore"
                    style="width: 100px"
                    size="mini"
                    placeholder=""
                  />
                  <input
                    class="com-search-input"
                    style="width: 50px; margin: 0 8px"
                    size="mini"
                    placeholder="{id}"
                  />
                  <input
                    class="com-search-input"
                    v-model="itemSkuAfter"
                    style="width: 100px"
                    size="mini"
                    placeholder=""
                  />
                </div>
                <input
                  class="com-search-input w100"
                  v-else-if="item.dataType == '01' && item.varUseFlag === null"
                  size="mini"
                  v-model="forms[index][item.attrId]"
                />
                <!--文本域-->
                <div
                  v-else-if="item.dataType == '04' || item.varUseFlag === '1'"
                >
                  <div class="variable-insert">
                    <div class="insert-link">
                      插入变量
                      <div class="variable-select-menu">
                        <ul>
                          <li
                            class="variable-select-box-text"
                            :key="number"
                            v-for="(record, number) in varList"
                            @click="
                              handleInsertVariable(
                                forms,
                                index,
                                item.attrId,
                                record.var
                              )
                            "
                          >
                            {{ record.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <i
                      @mouseenter="handleShowVarHelp"
                      @mouseout="showVarHelp = false"
                      class="el-icon-question"
                    ></i>
                  </div>
                  <textarea
                    class="w100"
                    :id="`textarea_${item.attrId}`"
                    :ref="`textarea_${item.attrId}`"
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="forms[index][item.attrId]"
                    show-word-limit
                    :rows="6"
                    size="mini"
                  >
                  </textarea>
                </div>
                <!--单选-->
                <select
                  class="com-search-input"
                  v-else-if="item.dataType == '02'"
                  v-model="forms[index][item.attrId]"
                  :disabled="item.disabled"
                >
                  <option value="">未选择</option>
                  <option
                    v-for="(item_2, index_2) in item.sPlatProVals"
                    :key="index_2"
                    :value="item_2.engValName"
                  >
                    {{ item_2.valName }}
                  </option>
                </select>
                <!--多选-->
                <el-select
                  clearable
                  v-model="forms[index][item.attrId]"
                  multiple
                  placeholder="请选择"
                  size="mini"
                  v-else-if="item.dataType == '03'"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item_2, index_2) in item.sPlatProVals"
                    :key="index_2"
                    :label="item_2.valName"
                    :value="item_2.engValName"
                  >
                  </el-option>
                </el-select>
                <!--枚举多选-->
                <div v-else-if="item.dataType == '06'" class="attrVal">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="forms[index][item.attrId]"
                    @change="checkde"
                    >全选</el-checkbox
                  >
                  <div style="margin: 15px 0"></div>
                  <el-checkbox-group
                    v-model="forms[index][item.attrId]"
                    @change="checkedManyVal"
                  >
                    <el-checkbox
                      v-for="(item_2, index_2) in item.sPlatProVals"
                      :key="index_2"
                      :label="item_2.engValName"
                      >{{ item_2.valName }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>

                <!--枚举单选-->
                <div v-else-if="item.dataType == '05'" class="attrVal">
                  <el-radio
                    v-model="forms[index][item.attrId]"
                    :key="index_2"
                    :label="item_2.engValName"
                    v-for="(item_2, index_2) in item.sPlatProVals"
                    >{{ item_2.valName }}</el-radio
                  >
                </div>
                <!--时间-->
                <el-date-picker
                  v-model="forms[index][item.attrId]"
                  type="datetime"
                  placeholder="选择日期时间"
                  v-else-if="item.dataType == '07'"
                >
                </el-date-picker>
              </div>

              <div class="form-remark">
                （{{ importTypeMap[item.importType] }}）
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.acceptedValues"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="sidebar__style">
        <div class="list__style">
          <div v-if="templateId">
            <a class="text-link" href="#selectTemplate">选择模板</a>
          </div>
          <div><a class="text-link" href="#basic">基础信息</a></div>
          <div><a class="text-link" href="#template">属性信息</a></div>
        </div>
        <div @click="handleBackTop" class="button__style goTop__style">
          返回<br />顶部
        </div>
        <div @click="handleSave" class="button__style submit__style">
          保存<br />{{ this.templateId ? "汇出" : "模板" }}
        </div>
      </div>
    </div>
    <VarHelp ref="varHelp" v-show="showVarHelp"></VarHelp>
    <PriceConfigDialog
      v-model="priceConfigVisible"
      @update="handleSetPrice"
    ></PriceConfigDialog>
    <SizeColorDialog
      :colorList="basicForm.colorList"
      :sizeList="basicForm.sizeList"
      v-model="sizeColorVisible"
      @update="handleSetColorSize"
    ></SizeColorDialog>
  </div>
</template>

<script type="text/ecmascript-6">
import BasicControl from "./basicControl";
import { getProList } from "@/api/plat/platType";
import Breadcrumb from "@/components/common/Breadcrumb";
import { mapGetters } from "vuex";
import { getProductTypeList, getTemplateTypeList } from "@/api/plat/platType";
import { addTemplate, getTemplateInfo, addRemit, addAmazonRemit, getVarListDesign, getVarListColl, getVarList, listDesignColorsize, listAmazonColorsize } from "@/api/template/template";
import { getOSSToken } from "@/api/setting";
import { getConfigKey } from "@/api/system/config";
import VarHelp from './varHelp.vue'
import PriceConfigDialog from './PriceConfigDialog'
import SizeColorDialog from './SizeColorDialog'
import draggable from "vuedraggable"
import { getDomainList, } from "@/api/system/domain"

export default {
  name: "createTemplate",
  components: { BasicControl, Breadcrumb, VarHelp, PriceConfigDialog, SizeColorDialog ,draggable },
  props: {
    templateId : {
      type : String,
      default: ''
    },
    shopId : {
      type : String,
      default: ''
    },
    designId : {
      type : String,
      default: ''
    }
  },
  data() {
    return {
      basicForm: {
        templateName: "",
        templateState: "US",
        saleForm: "03",
        platId: "",
        productPicAddr: "",
        exportFormat: "xlsx",
        attrList: [],
        price: '',
        quantity: '',
        skuList: [],
        external_product_id_type: '',
        external_product_id: '',
        color_name: '',
        groupNum: '',
        colorList: [],
        sizeList: [],
        picSizeH: '1600',
        picSizeW: '1600'
      },
      formItems: [],
      groups: [],
      forms: [],
      templateViews: ["Required" , "必須"],
      checkedAll: false,
      importTypeMap: {
        Required: "重要",
        Optional: "可选",
        Preferred: "首选",
      },
      platTypeList: [],
      optionProps: {
        value: "platId",
        label: "platName",
        children: "childrenTree",
      },
      feedProductType: "",
      itemType: "",
      imageGroup: [],
      imageSamples: ["1","2","3","4","5","6","7","8","9","10","11","12"],
      aliyunOssToken: {},
      varList: [],
      showVarHelp: false,
      priceConfigVisible: false,
      sizeColorVisible: false,
      attrMap: {},
      externalProductIdTypeOptions: [],
      productIds: [{
        name: '按设置生成',
        value: '1'
      },
      {
        name: '不汇出',
        value: '0'
      }],
      itemSkuBefore: '',
      itemSkuAfter: '',
      pictureAddresses: [],
      pId: '',
      sizeConfig: 1600,
      showPicSize: false,
      picSizeH: '',
      picSizeW: '',
      upload: '0'
    };
  },
  watch: {
    templateId: {
      handler(){
        if(this.templateId){
            this.loadData(this.templateId)
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  methods: {
    handleShowVarHelp(event){
      this.$refs['varHelp'].$el.style.top = event.clientY + 'px'
      this.showVarHelp = true
    },

    getTemplate({ platId, templateId }) {
      this.startLoading()
      getProList({ platId, templateId, templateState: this.basicForm.templateState ? this.basicForm.templateState : undefined }).then(
        (data) => {
          let forms = [];
          let groups = [];
          for (let i = 0; i < data.rows.length; i++) {
            //设置零售价和库存

            if(data.rows[i].fieldName === 'quantity'){
              this.basicForm.quantity = data.rows[i].engValName? data.rows[i].engValName.toString(): ''
            }
             if(data.rows[i].fieldName === 'external_product_id_type'){
              this.externalProductIdTypeOptions = data.rows[i].sPlatProVals
              this.basicForm.external_product_id_type = data.rows[i].engValName
            }
            if(data.rows[i].fieldName === 'external_product_id'){
              this.basicForm.external_product_id = data.rows[i].engValName
            }

            if(data.rows[i].fieldName === 'color_name'){
              this.basicForm.color_name = data.rows[i].engValName
            }

            if(data.rows[i].fieldName === 'relationship_type' && !data.rows[i].engValName){
              data.rows[i].engValName = 'Variation'
            }
             if(data.rows[i].fieldName === 'variation_theme' && !data.rows[i].engValName){
              data.rows[i].engValName = 'Size/Color'
            }
              if(data.rows[i].fieldName === 'footwear_age_group'){
              data.rows[i].engValName = 'Adult'
              // data.rows[i].disabled = true
            }
              if(data.rows[i].fieldName === 'age_range_description'){
              data.rows[i].engValName = 'adult'
              //  data.rows[i].disabled = true
            }


            if(data.rows[i].fieldName === 'item_sku'){
              if(data.rows[i].engValName){
              let fieldValue =  data.rows[i].engValName.split('{id}')
              if(fieldValue && fieldValue.length > 1){
                this.itemSkuBefore = fieldValue[0]
                this.itemSkuAfter = fieldValue[1]
              }
              } else{
                this.itemSkuBefore = ''
                this.itemSkuAfter = ''
              }
            }
            if(data.rows[i].groupBy == "Required"){
              data.rows[i].visible = true;
            }else{
              data.rows[i].visible = false;
            }


            this.attrMap[data.rows[i].attrId] = data.rows[i].fieldName
            if (groups.length == 0) {
              groups.push([data.rows[i]]);
              forms.push({ [data.rows[i].attrId]: data.rows[i].engValName });
              continue;
            }
            let isFind = false;
            for (let j = 0; j < groups.length; j++) {
              for (let k = 0; k < groups[j].length; k++) {
                if (groups[j][k].groupBy === data.rows[i].groupBy) {
                  isFind = true;
                  groups[j].push(data.rows[i]);
                  forms[j][data.rows[i].attrId] = data.rows[i].engValName;
                  break;
                }
              }
            }
            if (!isFind) {
              groups.push([data.rows[i]]);
              forms.push({ [data.rows[i].attrId]: data.rows[i].engValName });
            }
          }
          this.formItems = data.rows;
          this.forms = forms;
          this.groups = groups;
          this.getPicture()
          this.endLoading()
        }
      ).catch(()=>{
        this.endLoading()
      });
    },
    handleCheckAll() {
      if (this.checkedAll) {
        this.templateViews = ["Required", "Optional", "Preferred"];
      } else {
        this.templateViews = ["Required"];
      }
    },
    handleSavePicSize(){
      if(this.sizeConfig == 0){
        if(!this.picSizeW ){
          this.msgError('请输入宽度')
          return
        }
        if(!this.picSizeH){
          this.msgError('请输入高度')
          return
        }
        this.basicForm.picSizeW = this.picSizeW
        this.basicForm.picSizeH = this.picSizeH
      }else if(this.sizeConfig == 1600){
        this.basicForm.picSizeW = '1600'
         this.basicForm.picSizeH = '1600'
      }else if(this.sizeConfig == 800){
        this.basicForm.picSizeW = '800'
         this.basicForm.picSizeH = '800'
      }
      else if(this.sizeConfig == 1200){
        this.basicForm.picSizeW = '1200'
         this.basicForm.picSizeH = '1200'
      }
      else if(this.sizeConfig == 2000){
        this.basicForm.picSizeW = '2000'
        this.basicForm.picSizeH = '2000'
      }
      this.showPicSize = false
    },
    handleSetPrice(value){
      this.basicForm.skuList = value
    },
    async getPlatTypeList(platId) {
      if(!platId){
        platId = this.$route.query.platId
      }
      if(platId){
        let result = await getTemplateTypeList(platId);
        this.platTypeList = result.data;

        let templateId = this.$route.query.templateId
        let pId =  this.$route.query.pId
        let designId =  this.$route.query.designId
        if(this.$route.query.platId && !templateId && !pId && !designId){
          let platCode = this.getChild(this._.clone(result.data))
          this.getTemplate({platId : platCode});
        }
      }
       else{
        let result = await getProductTypeList({platNo: '04'});
        this.platTypeList = result.data;
      }
    },
    handleChangePlatId(value) {
      let vals = this.getCascaderObj(value, this.platTypeList);
      if (vals.length > 0) {
        let node = vals[vals.length - 1];
        // this.feedProductType = node.feedProductType;
        // this.itemType = node.itemType;
        this.getTemplate({platId : node.platId});
      }
    },
    handleChangeState(value){
      let platId = this.$route.query.platId
      if(platId){
        this.getTemplate({platId : platId})
      } else if(this.basicForm.platId && this.basicForm.platId.length > 0){
        this.getTemplate({platId : this.basicForm.platId[this.basicForm.platId.length -1]});
      }
    },
    getChild(tree){
      let platId = ''
      let platIdArray = []
      while(true){
        if(tree[0].childrenTree == null){
          break
        }
        platIdArray.push(tree[0].platId)
        tree = tree[0].childrenTree
      }
      platId = tree[0].platId
      platIdArray.push(platId)
      this.basicForm.platId = platId
      return platId
    },
    getCascaderObj(val, opt) {
      return val.map(function (value, index, array) {
        for (var itm of opt) {
          if (itm.platId == value) {
            opt = itm.childrenTree;
            return itm;
          }
        }
        return null;
      });
    },
    handleSetMainImage(record,index){
      this.imageGroup.map(item=>{
        item.isMain = false
      })
      record.isMain = true
      //插入到第一个元素
      this.imageGroup.splice(index , 1)
      this.imageGroup.unshift(record)
    },
    hanldeDeleteImage(record, index){
      this.imageGroup.splice(index , 1)
      let haveMain = false
      for(let record of this.imageGroup){
        if(record.isMain === true){
          haveMain = true
        }
      }
      if(!haveMain){
        this.imageGroup[0].isMain = true
      }
    },
    handleAddSample(record){
      this.imageGroup.push({
        imageUrl: record,
        isMain: this.imageGroup.length === 0 ? true : false
      })
    },
    handleSave(){
      this.$emit('save')
    },
    handleSaveForm() {
      //验证表单
      console.log(this.$refs)
      this.$refs["basicForm"].validate((valid) => {
        if (valid) {
          this.$refs["form0"][0].validate(async (auth)=>{
            if(!auth){
              return
            }
            if(this.imageGroup.length == 0){
              this.msgError('请设置产品图片')
              return
            }
            if(this.basicForm.saleForm == '04'){
              var thisCount = this.basicForm.color_name.split('{').length - 1
              if(thisCount < 2){
                this.msgError('颜色名称生成规则至少需要两个变量')
                return
              }
            }

            this.startLoading()
            let form = JSON.parse(JSON.stringify(this.basicForm));
            if(!form.picSizeH || !form.picSizeW ){
               form.picSizeH = '1600'
               form.picSizeW = '1600'
            }
            if(typeof(form.platId) === 'object'){
              form.platId = form.platId[form.platId.length - 1];
            }
            //设置图片
            for (let i=0; i< this.groups.length;i++) {
              for (let item of this.groups[i]) {
                if(item.groupBy === 'proPicGroup'){
                  for(let j =0;j<this.imageGroup.length;j++){
                    if(j === 0 && item.fieldName === 'main_image_url'){
                      this.forms[i][item.attrId] = this.imageGroup[j].imageUrl
                      break
                    } else if (item.fieldName === 'other_image_url' + j){
                      this.forms[i][item.attrId] = this.imageGroup[j].imageUrl
                      break
                    }
                  }
                }
              }
            }

            for (let i=0; i< this.groups.length;i++) {
              for (let item of this.groups[i]) {
                if(item.groupBy === 'proPicGroup'){
                  for(let j =this.imageGroup.length ;j<9;j++){
                    if (item.fieldName === 'other_image_url' + j){
                      this.forms[i][item.attrId] = null
                      break
                    }
                  }
                }
              }
            }
            //设置基础价格
            for (let i=0; i< this.groups.length;i++) {
              for (let item of this.groups[i]) {
                if(item.fieldName === 'external_product_id_type'){
                  this.forms[i][item.attrId] = this.basicForm.external_product_id_type
                  continue
                }
                if(item.fieldName === 'external_product_id'){
                  this.forms[i][item.attrId] = this.basicForm.external_product_id
                  continue
                }
                if(item.fieldName === 'quantity'){
                  this.forms[i][item.attrId] = this.basicForm.quantity
                  continue
                }
                if(item.fieldName === 'item_sku'){
                  let value = this.itemSkuBefore + '{id}' + this.itemSkuAfter
                  this.forms[i][item.attrId] = value
                  continue
                }
                if(item.fieldName === 'color_name'){
                   this.forms[i][item.attrId] = this.basicForm.color_name
                  continue
                }
              }
            }

            //设置提交表单
            for (let record of this.forms) {
              for (let key in record) {
                form.attrList.push({
                  attrId: key,
                  fieldName:  this.attrMap[key],
                  engValName: record[key],
                });
              }
            }
            let action = this.$route.query.action
            let templateId = this.$route.query.templateId
            if(templateId && action === 'edit'){
              form.templateId = templateId
            }else{
              form.templateId = null
            }
            form.codeType = this.basicForm.external_product_id_type
            //
            try {
               if(this.templateId){
                form.templateId = this.templateId
                form.shopId = this.shopId

                if(this.pId){
                  form.pId = this.pId
                  await addAmazonRemit(form)
                  this.msgSuccess("汇出成功，请到汇出记录中下载");
                }

                if(this.designId){
                  form.designId = this.designId
                  await addRemit(form)
                  this.msgSuccess("汇出成功，请到汇出记录中下载");
                }
              }
              else{
                await addTemplate(form);
                 this.msgSuccess("保存成功");
              }
              this.endLoading()
              this.$emit('submit')
            } catch (error) {
              this.endLoading()
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getPicture(){
      this.imageGroup = []
      for (let record of this.groups) {
        for (let i=0;i< record.length;i++) {
          if(record[i].groupBy === 'proPicGroup' && record[i].fieldName === 'main_image_url' && record[i].engValName){
            this.imageGroup.push({
              imageUrl: record[i].engValName,
              isMain: true
            })
          } else if(record[i].groupBy === 'proPicGroup' && record[i].engValName){
             this.imageGroup.push({
              imageUrl: record[i].engValName,
              isMain: false
            })
          }
        }
      }
    },
    getTreeNode(id ,list){
      let _this=this
      for (let i = 0; i < list.length; i++) {
        let node=list[i]
        if(node.platId=== id){
          return node
        } else{
          if(node.childrenTree && node.childrenTree.length>0){
            let res=_this.getTreeNode(id, node.childrenTree)
            if(res){
              return res
            }
          }
        }
      }
    },
    handleLoadTemplate(){

    },
    async loadData(templateId){
      if(templateId){
        let result = await getTemplateInfo(templateId)
        result.data.price = ''
        result.data.quantity = ''
        result.data.external_product_id_type = ''
        result.data.external_product_id = ''
        result.data.color_name = ''
        result.data.colorList = []
        result.data.sizeList = []
        if(!result.data.saleForm){
          result.data.saleForm = '03'
        }
        this.basicForm = result.data


        if(!this.basicForm.attrList){
          this.basicForm.attrList = []
        }
        if(this.basicForm.picSizeW && this.basicForm.picSizeH ){
          if(this.basicForm.picSizeW == 1600 && this.basicForm.picSizeH  == 1600){
            this.sizeConfig = 1600
          } else if(this.basicForm.picSizeW == 800 && this.basicForm.picSizeH  == 800){
            this.sizeConfig = 800
          }else if(this.basicForm.picSizeW == 1200 && this.basicForm.picSizeH  == 1200){
            this.sizeConfig = 1200
          }else if(this.basicForm.picSizeW == 2000 && this.basicForm.picSizeH  == 2000){
            this.sizeConfig = 2000
          } else{
            this.sizeConfig = 0
            this.picSizeW = this.basicForm.picSizeW
            this.picSizeH = this.basicForm.picSizeH
          }
        } else {
          this.sizeConfig = 1600
          this.basicForm.picSizeW = 1600
          this.basicForm.picSizeH = 1600
        }

        await this.getPlatTypeList(result.data.platId);
        result = await this.getTemplate({templateId})
      }else{
        await this.getPlatTypeList();
      }
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if(designId){
        let result = await listDesignColorsize({
          templateId: templateId,
          designId: designId,
        })
        this.basicForm.colorList = result.data.colorList
        this.basicForm.sizeList = result.data.sizeList
      }
      if(pId){
        let result = await listAmazonColorsize({
          templateId: this.templateId,
          pId: pId,
        })
        this.basicForm.colorList = result.data.colorList
        this.basicForm.sizeList = result.data.sizeList
      }

      // let node = this.getTreeNode(this.basicForm.platId, this.platTypeList);
      // this.feedProductType = node.feedProductType;
      // this.itemType = node.itemType;
    },
    //获取上传通行证
    getOssToken() {
      var _self = this
      getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
    handleSaveFile() {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = $("#fileUpload").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", $("#fileUpload")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            _self.imageGroup.push({
              imageUrl: fileUrl,
              isMain: _self.imageGroup.length === 0 ? true : false
            })
            $("#fileUpload").val(null)
          },
          error: function (data) {
             $("#fileUpload").val(null)
          },
        })
    },
    handleUploadImage(){
      document.querySelector('#fileUpload').click()
    },
    handleBackTop(){
      window.scroll(0,0)
    },
    handleInsertVariable(forms,index,attrId, value){
      this.insertAtCursor(forms,index,attrId, value)
      // forms[index][attrId] = (forms[index][attrId] ? forms[index][attrId] : '') + value
      // this.$refs['textarea_' + attrId][0].focus()
      // document.querySelector('.variable-select-menu').style.display = 'block'
    },
    async insertAtCursor(forms,index,attrId, value) {
      var myValue = value
      const myField = document.querySelector('#textarea_' + attrId)
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        forms[index][attrId] = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        forms[index][attrId] = (forms[index][attrId] ? forms[index][attrId] : '') + value
      }
    },
    async handleInsertColorSize(value){
      var myValue = value
      const myField = document.querySelector('#textarea_color')
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        this.basicForm.color_name = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        this.basicForm.color_name = (this.basicForm.color_name ? this.basicForm.color_name : '') + value
      }
    },
    async getVarList(){
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if (pId) {
        let result = await getVarListColl()
        this.varList = result.rows
      }  else if(designId) {
        let result = await getVarListDesign()
        this.varList = result.rows
      }else {
          let result = await getVarList()
        this.varList = result.rows
      }
    },
    onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
    },
    handleChangeProductType(){
      this.basicForm.external_product_id = '0'
      if(this.basicForm.external_product_id_type == "EAN" || this.basicForm.external_product_id_type == "UPC"){
        this.productIds = [{
          name: '按设置生成',
          value: '1'
        },
        {
          name: '不汇出',
          value: '0'
        }]
      }else{
        this.productIds =  [
        {
        name: '不汇出',
        value: '0'
         }]
      }
    },
    getConfigKey(){
      var _self = this
      getConfigKey("pic_url")
        .then(async (res) => {
          if (res.code == 200) {
            let array = []
            let result = await getDomainList({
              checkStatus: '02'
            })
            debugger
            if(result.rows.length > 0){
              for(let record of result.rows){
                array.push('http://' + record.busiDomain)
              }
            }
            array.push(res.msg)
            this.pictureAddresses  = array
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleSetColorSize(record){
      this.basicForm.colorList = record.colorList
      this.basicForm.sizeList = record.sizeList
    }
 },
 async mounted() {
    let templateId = this.$route.query.templateId
    let pId =  this.$route.query.pId

    let designId =  this.$route.query.designId
    let upload =  this.$route.query.upload
    this.pId = pId
    this.upload = upload
    if(templateId){
      this.loadData(templateId)
    }
    this.getOssToken()
    this.getVarList()
    this.getConfigKey()
    if(!pId && !templateId && !designId){
      this.getPlatTypeList('')
    }

  },
};
</script>

<style lang="scss" scoped>
#main {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #4934b2;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .check-list {
    margin: 0 0 16px 0;
  }
  ::v-deep .el-form-item__content {
    width: 600px;
  }
  .form-title {
    line-height: 40px;
    font-size: 16px;
  }
  .form-control {
    float: left;
    width: 500px;
  }
  .form-remark {
    float: left;
    color: #606266;
  }
  .image-hint {
    color: #606266;
  }
  li.sort-img-item {
    background: #eeeeee;
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
    }
  }

  .extra-image-ul > div > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > div > li > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  li.add-image-button > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope,
  .detail-image-ul.lazada > div > li .wish-product-img-ope,
  .wish-product-img > div > li .wish-product-img-ope {
    width: calc(100% - 8px);
    padding: 1px 4px;
    background: rgb(73, 52, 178);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    line-height: 20px;
    text-align: left;
    font-size: 12px;
    .set-main {
      float: left;
      cursor: pointer;
    }
    .set-delete {
      float: right;
      cursor: pointer;
    }
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope > a,
  .detail-image-ul.lazada > div > li .wish-product-img-ope > a,
  .wish-product-img > div > li .wish-product-img-ope > a {
    color: #fff;
  }
  .item-badge {
    position: absolute;
    color: rgb(255, 165, 79);
    font-weight: bold;
    font-size: 14px;
    top: -8px;
    left: 0;
    // -ms-transform: rotate(-35deg);
    // -webkit-transform: rotate(-35deg);
    // transform: rotate(-35deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
    z-index: 1;
  }
  .add-image-button {
    font-size: 24px;
    vertical-align: 15px;
    position: relative;
  }
  .add-image-button:hover .variable-select-box {
    display: block;
  }
  .variable-select-box {
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-box li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-box > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-box > ul > li:hover .variable-pick-ul {
    display: block;
  }

  .variable-pick-ul {
    position: absolute;
    top: -1px;
    left: 76px;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    z-index: 10;
    display: none;
  }
  .variable-pick-ul li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-pick-ul li {
    color: #000;
    white-space: nowrap;
  }
}
.insert-link {
  color: #4934b2;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #4934b2;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #4934b2;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #4934b2;
  color: #fff;
  background-color: #4934b2;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-label {
  display: inline-block;
  position: relative;
  line-height: 20px;
}
.field-name {
  position: absolute;
  right: 0;
  text-align: right;
  top: 20px;
  line-height: 20px;
}
.com-search-input {
  height: 28px;
  border: 1px solid rgb(225, 227, 229);
  vertical-align: top;
}
select {
  color: rgb(89, 90, 90);
  border-radius: 4px;
  width: 100%;
}

input:focus,
textarea:focus,
select:focus,
textarea:focus {
  border: 1px solid #4934b2;
  box-shadow: 0 0 2px #a3c3f9;
  outline: none;
}
.w70 {
  width: 70% !important;
}
.w100 {
  width: 100% !important;
}
.imgSize-box {
  background: #fff;
  border: 1px solid rgb(221, 221, 221);
  min-width: 160px;
  p {
    padding: 7px 10px;
    font-size: 12px;
    line-height: 26px;
  }
  .ml5 {
    margin-left: 5px !important;
  }
}
</style>
